<div class="row" style="font-family: 'Inconsolata', monospace;">
  <section class="content col-md-12 groups-container">
    <div class="row" style="margin-top: 32px;">
      <div class="col-md-12" style="padding-right: 5px;padding-left: 5px;">
        <div class="box" style="border-radius: 0px;min-height: unset; margin-top: -40px;">
          <div class="box-body">
            <form class="form-horizontal" #activityForm="ngForm">
              <div class="form-group row" style="margin-bottom: -15px;">

                <label class="col-sm-1 control-label grp-lbl" style="padding-left: 0 !important;width: 5%;">Groupe</label>
                <div class="col-sm-2 grp-slct">
                  <select class="form-control input-sm" name="group" [(ngModel)]="selectedGroup"  (ngModelChange)="onGroupChange()" required>
                    <option *ngFor="let group of groups" [ngValue]="group">
                      {{group?.nom | capitalizefirst}}
                    </option>
                  </select>
                </div>
                
                <label class="col-sm-1 control-label dd-lbl" style="padding-left: 0 !important;width: 6%;">Date début</label>
                <div class="col-sm-2 dd-npt">
                    <div class="input-group">
                        <input type="text" class="form-control input-sm" bsDatepicker name="startDate" [(ngModel)]="startDate"
                        [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY, HH:mm' , containerClass: 'theme-dark-blue'}" placement="bottom" [maxDate]="endDate" >
                        <span class="input-group-addon"><i class="fa fa-clock-o"></i></span>
                    </div>
                </div>
                <label class="col-sm-1 control-label df-lbl" style="padding-left: 0 !important;width: 5%;">Date fin</label>
                <div class="col-sm-2 df-npt">
                  <div class="input-group">
                      <input type="text" class="form-control input-sm" bsDatepicker name="endDate" [(ngModel)]="endDate"
                      [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY, HH:mm', containerClass: 'theme-dark-blue'}" placement="bottom" [minDate]="startDate">
                      <span class="input-group-addon"><i class="fa fa-clock-o"></i></span>
                  </div>
                 </div>
                
                <div class="col-sm-1 form-btns" style="width: 3%;">
                  <button type="button" class="btn btn-success btn-flat btn-sm"
                    [disabled]="loadingSettings || !activityForm.form.valid" (click)="loadAllClasifications()" title="Valider" style="border-radius: 5px;">
                    <b><i class="fa fa-play" aria-hidden="true"></i></b>
                  </button>
                </div>

                <div class="col-sm-1 form-btns">
                  <button type="button" class="btn btn-warning btn-flat btn-sm" [disabled]="loadingSettings || groups.length == 0"
                    (click)="classificationModal.show()" title="Coefficient" style="border-radius: 5px;position: relative;">
                    <b><i class="fa fa-gear" aria-hidden="true" *ngIf="!loadingSettings"></i></b> 
                    <i class="fa fa-spinner fa-spin" *ngIf="loadingSettings"></i>
                    Paramétrage
                  </button>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">

      <ng-container
        *ngIf="!loadingSettings && !classification.mileage && !classification.hActivity && !classification.workingTime && !classification.fueling && !classification.offense && !classification.sinistre && !classification.turnover">
        <div class="col-xl-12 col-md-12 mb-12 col-xs-12" style="padding-right: 5px;padding-left: 5px;">
          <div class="alert alert-warning alert-dismissible text-center">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true">
              ×
            </button>
            <h4 style="color: white">
              <i class="fa fa-info-circle"></i> Information
            </h4>
            Veuillez définir votre coefficient
            <ng-container *ngIf="groups.length > 0">
            <span type="button" class="btn btn-flat btn-sm" (click)="classificationModal.show()" title="Coefficient">
              <b><i class="fa fa-gear" aria-hidden="true"></i></b>
            </span>
          </ng-container>
          </div>
        </div>
      </ng-container>


      <!-- Result-->
        <ng-container>
          <div class="col-md-8" style="padding-right: 5px;padding-left: 5px;">
            <div>
              <div class="box box-info collapsed-box">
                <div class="box-header with-border text-center">
                  <div *ngIf="loadingSettings || isAllLoading() || loadingGroup" style="font-size: 12px;margin-top: 8px;">
                    <i class="fa fa-spinner fa-spin" *ngIf="loadingSettings || isAllLoading() || loadingGroup"></i> Chargement ...
                  </div>
                  <app-classification-result-chart [driverScores]="driverScores"></app-classification-result-chart>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Activity Percentage-->
        <ng-container *ngIf="classification.hActivity">
          <div class="col-md-4" style="padding-right: 5px;padding-left: 5px;">
            <div>
              <div class="box box-info collapsed-box">
                <div class="box-header with-border text-center">
                  <div *ngIf="loadingActivity" style="font-size: 12px;margin-top: 8px;">
                    <i class="fa fa-spinner fa-spin" *ngIf="loadingActivity"></i> Chargement ...
                  </div>
                  <app-classification-percentage-chart [activities]="activities">
                  </app-classification-percentage-chart>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
  
        <!-- KM -->
        <ng-container *ngIf="classification.mileage">
          <div class="col-md-4" style="padding-right: 5px;padding-left: 5px;">
            <div>
              <div class="box box-info collapsed-box">
                <div class="box-header with-border text-center">
                  <div *ngIf="loadingActivity" style="font-size: 12px;margin-top: 8px;">
                    <i class="fa fa-spinner fa-spin" *ngIf="loadingActivity"></i> Chargement ...
                  </div>
                  <app-classification-kmchart [activities]="distanceDriven"></app-classification-kmchart>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
  
        <!-- Fueling -->
        <ng-container *ngIf="classification.fueling">
          <div class="col-md-4" style="padding-right: 5px;padding-left: 5px;">
            <div>
              <div class="box box-info collapsed-box">
                <div class="box-header with-border text-center">
                  <div *ngIf="loadingFueling" style="font-size: 12px;margin-top: 8px;">
                    <i class="fa fa-spinner fa-spin" *ngIf="loadingFueling"></i> Chargement ...
                  </div>
                  <app-classification-fueling-chart [fuelings]="fuelings"></app-classification-fueling-chart>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
  
        <!-- Offense -->
        <ng-container *ngIf="classification.offense">
          <div class="col-md-4" style="padding-right: 5px;padding-left: 5px;">
            <div>
              <div class="box box-info collapsed-box">
                <div class="box-header with-border text-center">
                  <div *ngIf="loadingOffense" style="font-size: 12px;margin-top: 8px;">
                    <i class="fa fa-spinner fa-spin" *ngIf="loadingOffense"></i> Chargement ...
                  </div>
                  <app-classification-offense-chart [offenses]="offenses">
                  </app-classification-offense-chart>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
  
        <!-- Sinistre -->
        <ng-container *ngIf="classification.sinistre">
          <div class="col-md-4" style="padding-right: 5px;padding-left: 5px;">
            <div>
              <div class="box box-info collapsed-box">
                <div class="box-header with-border text-center">
                  <div *ngIf="loadingSinistre" style="font-size: 12px;margin-top: 8px;">
                    <i class="fa fa-spinner fa-spin" *ngIf="loadingSinistre"></i> Chargement ...
                  </div>
                  <app-classification-sinistre-chart [sinistres]="sinistres">
                  </app-classification-sinistre-chart>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        
      <!-- Hour Activity -->
        <ng-container *ngIf="classification.workingTime">
          <div class="col-md-4" style="padding-right: 5px;padding-left: 5px;">
            <div>
              <div class="box box-info collapsed-box">
                <div class="box-header with-border text-center">
                  <div *ngIf="loadingActivity" style="font-size: 12px;margin-top: 8px;">
                    <i class="fa fa-spinner fa-spin" *ngIf="loadingActivity"></i> Chargement ...
                  </div>
                  <app-classification-hour-activity-chart [activities]="pathTime">
                  </app-classification-hour-activity-chart>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
  

      <!-- Turn Over -->
        <ng-container *ngIf="classification.turnover">
          <div class="col-md-4" style="padding-right: 5px;padding-left: 5px;">
            <div>
               <div class="box box-info collapsed-box">
                <div class="box-header with-border text-center">
                  <div *ngIf="loadingTurnOver" style="font-size: 12px;margin-top: 8px;">
                    <i class="fa fa-spinner fa-spin" *ngIf="loadingTurnOver"></i> Chargement ...
                  </div>
                  <app-classification-driver-turn-over-chart [driversTurnOver]="turnOvers">
                  </app-classification-driver-turn-over-chart>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
            
    </div>

  </section>
</div>





<!-- ============================== ADD MODAL (START) ========================== -->
<div class="modal fade" bsModal #classificationModal="bs-modal" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" (click)="classificationModal.hide()">&times;</button>
        <h4 class="modal-title" style="font-family: 'Inconsolata', monospace;font-weight: bold;color: #3c8dbc;">
          <i class="fa fa-plus"></i>
          Réglage des coefficients
        </h4>
      </div>
      <div class="modal-body">
        <span class="text-warning">
          * vous pouvez choisir 4 paramètres comme max.
        </span>
        <br />
        <span class="text-warning">
          * Le total du coefficient doit être égal à 20/20
        </span>
        <div class="box-body">
          <app-activity-vehicle-classification-form [groups]="groups" [coefficient]="classification"
            (classificationWasSaved)="classificationWasSaved($event)">
          </app-activity-vehicle-classification-form>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- ============================== ADD/UPDATE MODAL (END) ======================== -->